import { deleteMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const DELETE_BRANCH_PROVIDER = 'DELETE_BRANCH_PROVIDER';
export const DELETE_BRANCH_PROVIDER_SUCCESS = 'DELETE_BRANCH_PROVIDER_SUCCESS';
export const DELETE_BRANCH_PROVIDER_FAILURE = 'DELETE_BRANCH_PROVIDER_FAILURE';

// Action Creators
export const fetchDeleteBranchProvider = () => ({
  type: DELETE_BRANCH_PROVIDER,
});

export const fetchDeleteBranchProviderSuccess = (data) => ({
  type: DELETE_BRANCH_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchDeleteBranchProviderFailure = (error) => ({
  type: DELETE_BRANCH_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteBranchProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchDeleteBranchProvider(data, external));
    try {
      const response = await deleteMethodWithToken(
        url.deleteBranchListProvider + external?.id + '/delete/'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchDeleteBranchProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchDeleteBranchProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchDeleteBranchProviderFailure(error.message));
    }
  };
};
